import React from 'react';
import './homeBanner.css';

function HomeBanner() {
    return (
        <section id="logos-572">
            <div className="cs-container">
                <img src="/images/mantra.jpg" alt="Mantra" >
                </img>
            </div>
        </section>
    );
}
export default HomeBanner;